export default __webpack_public_path__ + "static/media/mongo.202e2c9e.png";